<template>
<div>
  <!-- <span v-if="testObject" v-text="testObject" ></span> -->

<!-- https://serversideup.net/uploading-files-vuejs-axios/ -->

<!-- Assistant <button @click="sitioStatus(generalInformation[0].data)" class="button is-small" v-text="(generalInformation[0].data==1)?'Desactivar sitio':'Activar sitio'" >  </button> -->

<!-- <div class="column is-2" align="right"> <br> -->
<div>
  <label> Search  </label><br>
  <input class="input is-success" v-model="searchText" @input="searchSupport" placeholder="Issue, alert, service, contact...">
</div> <br>
<!-- {{this.supportSelectedList}} -->
<div v-if="this.supportSelectedList!=''">

<div class="columns">
  <div class="column">
    <!-- {{this.supportSelectedList.title}} -->
    
    <span v-if="$cookies.get('RhSession').rol==1" class="tag is-link is-large " v-text="'Title'" > </span>
    <span v-if="$cookies.get('RhSession').rol==1" v-text="Title" ></span> <input v-if="$cookies.get('RhSession').rol==1" class="input is-xsmall" v-model="supportTitle" placeholder="Title">
    <span class="title" v-else v-text="this.supportTitle" style="color:green;" ></span>
  </div>
  <div class="column">
    <!-- {{this.supportSelectedList.supportType}} -->
    <article class="message">
        <div class="message-header">
        <label>Support type </label>
        </div>
        <div class="message-body">
          <span v-if="$cookies.get('RhSession').rol!=1" v-text="this.supportTypesList[this.supportTypeSelected-1]['name']"></span>
          <div v-if="$cookies.get('RhSession').rol==1" class="select is-fullwidth"> 
            <!-- <select v-model="supportType" @change="getSupportType"> -->
              <select v-model=" supportTypeSelected ">
              <option class="is-size-7" v-for="type in supportTypesList" :key="type.id" :value="type.id">{{type.name}} </option>
            </select>
          </div>
        </div>
    </article>
  </div>
  <div class="column">
    <article class="message">
        <div class="message-header">
        Application/Service handled by
        </div>
        <div class="message-body">
        <input v-if="$cookies.get('RhSession').rol==1" class="input is-xsmall" v-model="supportHandledBy" placeholder="Handled by">
        <span v-else v-text="this.supportHandledBy"></span>
        </div>
    </article>
  </div>
</div>
  <div class="columns">
    <div class="column">
      <span class="tag is-link is-medium">Description</span>
      <article class="message is-link">
        <div class="message-body">
          <textarea v-if="$cookies.get('RhSession').rol==1" class="textarea" rows="10" v-model="supportDescription" placeholder="Description"></textarea>
          <textarea readonly v-else class="textarea" rows="10" v-text="this.supportDescription"></textarea>
        </div>
      </article>
    </div>
    <div class="column">
      <span class="tag is-link is-medium ">Troubleshoot</span>
      <article class="message is-link">
        <div class="message-body">
            <textarea v-if="$cookies.get('RhSession').rol==1" class="textarea" rows="10" v-model="supportTroubleshoot" placeholder="Troubleshoot"></textarea>
            <textarea readonly v-else class="textarea" rows="10" v-text="this.supportTroubleshoot"></textarea>
            
        </div>
      </article>
    </div>
  </div>

  <div class="columns">
    <div class="column is-4">
      <article class="message">
        <div class="message-header">
          Classification
        </div>
        <div class="message-body">
          <input v-if="$cookies.get('RhSession').rol==1" class="input" v-model="supportClassification" placeholder="Classification">
          <span v-else v-text="this.supportClassification"></span>
        </div>
      </article>
    </div>
    <div class="column is-4">
      <article class="message">
        <div class="message-header">
          url
        </div>
        <div class="message-body">
          <input v-if="$cookies.get('RhSession').rol==1" class="input" v-model="supportUrl" placeholder="url">
          <a v-else :href="this.supportUrl" target="_blank" style="overflow-wrap: break-word" >{{this.supportUrl}}</a>
        </div>
      </article>
    </div>
    <div class="column is-4">
      <article class="message">
        <div class="message-header">
          Phone
        </div>
        <div class="message-body">
          <input v-if="$cookies.get('RhSession').rol==1" class="input" v-model="supportPhone" placeholder="Phone">
          <span v-else v-text="this.supportPhone"></span>
        </div>
      </article>
    </div>
    
  </div>
  <article class="message">
        <div class="message-header">
          File
        </div>
        <div class="message-body">
          <input v-if="$cookies.get('RhSession').rol==1" class="input" v-model="supportFile" placeholder="File">
            <a v-else :href="this.supportFile" target="_blank">{{this.supportFile}}</a>
        </div>
  </article>


            <a v-if="$cookies.get('RhSession').rol==1" style="margin-top:10px;" class="button is-small is-info" @click="updateSupport">Update</a>

</div>

<template v-for="support in supportList">
  <div class="columns" v-if="$cookies.get('RhSession').rol==1">
      <!-- <li> <button style="margin-right:10px; margin-bottom:10px;" @click="changeTourStatus(support.id,support.status)" class="button is-small" v-text="(support.status==1)?'Deactivate':'Activate'" > </button> <router-link :style="setColor(support.status)" :to="'/servicios/'+support.id"> <font-awesome-icon icon="tools" /> {{support.title}}</router-link>  </li> -->
      <div  class="column is-1"> <button style="margin-right:10px; margin-bottom:10px;" @click="changeSupportStatus(support.id,support.status)" class="button is-small" v-text="(support.status==1)?'Deactivate':'Activate'" > </button> </div><div class="column"> <a :style="setColor(support.status)" @click="getSupport(support.id)" > <font-awesome-icon icon="tools" /> {{support.title}} <br> <spam style="color:grey" > {{support.description}} </spam> </a>  </div>
  </div>

  <div class="columns" v-else>
      <!-- <li> <button style="margin-right:10px; margin-bottom:10px;" @click="changeTourStatus(support.id,support.status)" class="button is-small" v-text="(support.status==1)?'Deactivate':'Activate'" > </button> <router-link :style="setColor(support.status)" :to="'/servicios/'+support.id"> <font-awesome-icon icon="tools" /> {{support.title}}</router-link>  </li> -->
      <div v-if="support.status==1" class="column"> <a :style="setColor(support.status)" @click="getSupport(support.id)" > <font-awesome-icon icon="tools" /> {{support.title}} <br> <spam style="color:grey" > {{support.description}} </spam> </a>  </div>
  </div>
</template>

  
  

</div>
</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'

export default {
  components:{
    DatePick,
    VueClockPicker
  },
  data () {
    return {
      subSelect:'',
      toursList:[],

      supportList:[],

      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      fecha:moment().add(1, 'day').format('YYYY-MM-DD'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:2,
      ninos:0,
      infantes:0,
      cliente:'',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,
      generalInformation: [],
      supportSelected:'',
      supportSelectedList: [],
      supportTypesList: [],

      supportTypeSelected:'',
      supportTitle:'',
      supportClassification:'',
      supportHandledBy:'',
      supportFile:'',
      supportUrl:'',
      supportTroubleshoot:'',
      supportPhone:'',

      host: 'booking.sistemy.mx',
      hostSupport: 'support.sistemy.mx'
      // host: 'localhost'

    }
  },
  created(){
    // this.getSupport();
    this.getSupportType();
    this.getTiposGenerales();
    this.getHoteles();
    this.getVendedores();
    this.getMonedas();
    this.getTours();
    this.getIdiomas();
    this.getNacionalidades();
    this.getSalidas();
    this.general();
    // this.test();
  },
  computed:{
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.items;
      }
      return self.items.filter(function(item){

        var str = self.searchText;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    },
    itemsSearched2 : function(){
      var self = this;
      if( self.searchText2 == ''){
        return self.items2;
      }
      return self.items2.filter(function(item){

        var str = self.searchText2;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    }
  },
  methods:{
    updateSupport () {
      
      var item = this.supportSelectedList;
      console.log(this.supportTitle,'<--support')
      
      var params = {
        action: 'justUpdate',
        tabla: 'support',
        set: " title = '"+this.supportTitle+"', description = '"+this.supportDescription+"', supportType = "+this.supportTypeSelected+", classification = '"+this.supportClassification+"', handledBy = '"+this.supportHandledBy+"', file = '"+this.supportFile+"', url = '"+this.supportUrl+"', troubleshoot = '"+this.supportTroubleshoot+"', phone = '"+this.supportPhone+"' ",
        where: 'id = '+item.id
      }
      axios.post(`http://${this.hostSupport}/assignFunction.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              
              this.$snotify.success('Correct', 'Updated', {
               timeout: 4000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });

            }else{
              console.log('error');
            }
          });

    },
    getSupportType(){
        var estancia=this;
        var select = `*`;
        var tabla = "supportType";
        var where = ` `;
        axios.get(`http://${this.hostSupport}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
              console.log(response.data,'<--support type list')
                estancia.supportTypesList=response.data;
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    sitioStatus (status) {
      var newStatus = (status == 1)?'0':'1';
      console.log(newStatus,'newStatus')
      var params = {
        action: 'justUpdate',
        tabla: 'general',
        set: `data = ${newStatus}`,
        where: 'id = 1'
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              this.general()
            }else{
              console.log('error');
            }
          });
    },
    general () {
      console.log('en general')
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'general',
          where: ''
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ 
            console.log(response,'response')
         if (response.status == 200 ) {
            this.generalInformation=response.data
         }else{
           console.log('error: No se obtuvo la información general');
         }
       });
    },
    setColor (status) {
      var colorSetted = (status==1)?"color:green;":"color:red;";
      return colorSetted;
    },
    changeTourStatus (id,status) {
      console.log("Action to change status",id,status)
      if(status==1){
        status=0;
        console.log(status,"on ==1")
      }else{
        status=1;
        console.log(status,'on else')
      }
      var params = {
        action: 'justUpdate',
        tabla: 'tour',
        set: `activo = ${status}`,
        where: 'id = '+id
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              this.getTours()
            }else{
              console.log('error');
            }
          });
    },
    changeSupportStatus (id,status) {
      console.log("Action to change status",id,status)
      if(status==1){
        status=0;
        console.log(status,"on ==1")
      }else{
        status=1;
        console.log(status,'on else')
      }
      var params = {
        action: 'justUpdate',
        tabla: 'support',
        set: `status = ${status}`,
        where: 'id = '+id
      }
      axios.post(`http://${this.hostSupport}/assignFunction.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              this.searchSupport()
            }else{
              console.log('error');
            }
          });
    },
    clear () {
      console.log("limpiando form");
      this.subSelect=1;
      this.tour='';
      this.tour2='';
      this.tour3='';
      this.tour4='';
      this.tipo='';
      this.nacionalidad='';
      this.idioma='';
      this.salida='';
      this.fecha=moment().add(1, 'day').format('YYYY-MM-DD');
      this.fecha2='';
      this.fecha3='';
      this.fecha4='';
      this.hora='';
      this.searchText='';
      this.searchText2='';
      this.hotel='';
      this.hotelId='';
      this.hotelPickup='';
      this.vendedor='';
      this.vendedorId=null;
      this.adultos=2;
      this.ninos=0;
      this.infantes=0;
      this.cliente='';
      this.habitacion='';
      this.cupon='';
      this.balance=0;
      this.moneda=null;
      this.observaciones='';
      this.confirma='';
      this.servicio=1;
      this.horario=1;
      this.cortesia=2;
    },
    test(){
      console.log("En test");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'reservaciones',
          where: ''
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de test')
         if (response.status == 200 ) { console.log("bien test");
         this.testObject=response
           this.$snotify.success('test', 'Correcto', {
               timeout: 4000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

    },
    fechas (r) {
      if(r==2){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      }else if (r==3){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      }else if(r==4){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
        this.fecha4=moment().add(4, 'days').format('YYYY-MM-DD');
      }
    },
    reservar () {
      console.log("reservar 1");
      var estancia=this;
      var posicion=1;
      if(this.ninos==null){
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }else{
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+this.ninos+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }
      this.confirma=confirmacion;
      $("#modalConfirmacion").addClass("is-active");
      console.log(confirmacion);
      var params = {
        action : 'insertPost',
        table : 'reservaciones',
        columns : 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion, servicio, cortesia, horario',
        values : ` ${$cookies.get('RhSession').id}, '${estancia.fecha}',${estancia.tour.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}',${estancia.servicio},${estancia.cortesia},${estancia.horario} `
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

       if(this.subSelect==2 || this.subSelect==3 || this.subSelect==4){
         var posicion=2;
         console.log("Insertando el día 2 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==3 || this.subSelect==4){
         var posicion=3;
         console.log("Insertando el día 3 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==4){
         var posicion=4;
         console.log("Insertando el día 4 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }
    },
    elegido:function(item){
      this.searchText='';
      this.hotel = item.nombre;
      this.hotelId = item.id;
      this.hotelPickup = item.pickup;
      console.log(this.tour.pickup,'tour.pickup');
      console.log(item,'item');
      if(this.tour.pickup=='' || this.tour.pickup==null ){
        this.hora=item.pickup;
      }
    },
    elegido2:function(item){
      this.searchText2='';
      this.vendedor = item.nombre;
      this.vendedorId = item.id;
    },
    getHoteles(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre, pickup',
        //   table: 'hoteles',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre, pickup`;
        var tabla = "hoteles";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            // estancia.hotelesList  = response.data;
            estancia.items = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
            estancia.moneda=response.data[0].id;
          }else{
            console.log('error');
          }
        });
    },
    getVendedores(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'vendedores',
        //   where: 'activo=1',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "vendedores";
        var where = "activo=1";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.items2 = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getTours(){
      var estancia=this;
      var select = `*`;
      var tabla = "tour";
      var where = "";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.toursList=response.data;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    // getSupport(){
    //   var estancia=this;
    //   var select = `*`;
    //   var tabla = "support";
    //   var where = "";
    //   axios.get(`http://${this.hostSupport}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
    //     .then(function(response){
    //       if (response.status == 200 ) {
    //           estancia.supportList=response.data;
    //       }else{
    //         console.log('error getTours');
    //       }
    //     }); //ends axios
    // },
    getSupport(idSupport){
      console.log("En getSupport()");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'support',
          where: 'id='+idSupport
      }
          axios.post(`http://${this.hostSupport}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ 
         if (response.status == 200 ) {
         this.supportSelectedList=response.data[0]
         this.supportTitle=response.data[0].title
         this.supportDescription=response.data[0].description
         this.supportTypeSelected=response.data[0].supportType
         this.supportClassification=response.data[0].classification
         this.supportHandledBy=response.data[0].handledBy
         this.supportFile=response.data[0].file
         this.supportUrl=response.data[0].url
         this.supportTroubleshoot=response.data[0].troubleshoot
         this.supportPhone=response.data[0].phone
        
          //  this.$snotify.success('test', 'Correcto', {
          //      timeout: 4000,
          //      showProgressBar: false,
          //      closeOnClick: false,
          //      pauseOnHover: true
          //    });
             this.supportList=[];
         }else{
           console.log('error: No reservado');
         }
       });

    },
    searchSupport(){
      this.supportSelectedList = [];
      console.log("searching...",this.searchText);
      var estancia=this;
      var select = `*`;
      var tabla = "support";
      var where = `CONCAT(title, description, supportType, classification, troubleshoot, handledBy, file, url, phone) LIKE '%25${this.searchText}%25' `;
      axios.get(`http://${this.hostSupport}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response)=>{
          if (this.searchText != '' && response.data != 'no hay datos' ) {
            console.log('sapbe')
              this.supportList=response.data;
          }else{
            console.log(this.supportList,'<--in else')
            this.supportList=[];
            console.log('nothing in searchSupport');
          }
        }); //ends axios
    },
    getTipos(){
      console.log(this.tour,'tour');
      this.hora=this.tour.pickup;
      console.log(this.hora,'hora');
      if(this.tour!=''){
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId like '%,${estancia.tour.id},%' `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = ` tourId like '%25%2C${estancia.tour.id}%2C%25' `;
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposList=response.data;
                if(estancia.tour.id!=6){
                  console.log(response,'response getTipos')
                  estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
      }
    },
    getTiposGenerales(){
      console.log("en reservar")
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId = "0" `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = "tourId = '0'";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposGeneralesList=response.data;
                if(estancia.tipo==''){
                // if(estancia.tipo=='' || (estancia.tiposList.length<1 && tour.id==6) ){
                 estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getIdiomas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"idioma",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "idioma";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.idiomasList=response.data;
              estancia.idioma=response.data[4].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getSalidas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"lugar_salida",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "lugar_salida";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.salidasList=response.data;
              estancia.salida=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getNacionalidades(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"nacionalidad",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "nacionalidad";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.nacionalidadesList=response.data;
              estancia.nacionalidad=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    tipoCuponF(n){
      if(this.tipoCupon==1){
        $("#1").addClass("is-active");
      }
      if(n==2){
        $("#2").addClass("is-active");
      }
      if(n==3){
        $("#3").addClass("is-active");
      }
      if(n==4){
        $("#4").addClass("is-active");
      }
      this.tipoCupon=n;
    },
    cerrarModalConfirmacion:function(){
      this.clear();
      $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
